module.exports = __webpack_public_path__ + "assets/img/252af7b290fbded8aa58ed85deaa2a76.png";